import { mapGetters, mapState } from 'vuex'

export const userMixin =  {
  
  data () {
      return {
        id: this.$route.params.id
      }
  },
  computed: {
    ...mapGetters(
        { isAuthenticated: 'auth/isAuthenticated' }
    ),
    ...mapState({
          username: state => state.user.identity.username,
          user: state => state.user.identity
    })
  }
}

export const imageMixin =  {

    computed: {

        filteredByAll() {
            return this.$store.getters['image/filteredByAll']
        },
        filteredByUser() {
            return this.$store.getters['image/filteredByUser']
        },
        filteredByCollective() {
            return this.$store.getters['image/filteredByCollective']
        },
        filteredByProject() {
            return this.$store.getters['image/filteredByProject']
        },
        filteredByCompetition() {
            return this.$store.getters['image/filteredByCompetition']
        },
        filteredByWorkshop() {
            return this.$store.getters['image/filteredByWorkshop']
        },
        filteredById() {
            return this.$store.getters['image/filteredById']
        },
        filteredByVoted() {
            return this.$store.getters['image/filteredByVoted']
        }
    }
}

export const groupMixin =  {

    computed: {
        filteredItems() {
            return this.groups.filter((i) => {
                return !this.type || (i.type === this.type);
            })
        },
        
    },
    methods: {
        removeGroup(type, objectId) {
            let objectToDelete = this.image[type].findIndex(obj => obj.id == objectId)
            this.image[type].splice(objectToDelete,1)
            },
        addGroup(type, obj) {
            this.image[type].push(obj)  
        }
    }
}
